<template>
    <v-card>
        <v-card-text class="p-3 overflow-y-auto">
            <v-row class="calculator-container">
                <v-col cols="1">
                    <v-text-field 
                        v-model="scrapStart" 
                        variant="outlined"
                        step="1"
                        min="0"
                        type="number" 
                    ></v-text-field>
                </v-col>
                <span>%</span>
                <v-col cols="1">
                    <v-text-field 
                        v-model="scrapEnd" 
                        variant="outlined"
                        step="1"
                        min="0"
                        type="number"
                        :error-messages="
                            errors.scrapEnd
                        " 
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="setQtyPerCalculated"
                >Set
            </v-btn>
            <v-btn color="blue darken-1" text @click="close"
                >Cancel
            </v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "QtyPerCalculator",
        emits: ["qtyPerCalculatorReceived", "closeQtyPerCalculator"],
        props: {},
        data: () => ({
            scrapStart: 1,
            scrapEnd: null,
            errors: {}
        }),
        watch: {},
        created() {},
        mounted() {},
        methods: {
            setQtyPerCalculated() {
                if (!this.scrapEnd || (this.scrapEnd < .0000001)) {
                    this.errors = {
                        scrapEnd: "Required",
                    };

                    return;
                } else {
                    let value = this.scrapStart / this.scrapEnd;
                    this.$emit("qtyPerCalculatorReceived", value);
                }
            },
            close() {
                this.$emit("closeQtyPerCalculator");
            }
        },
    };
</script>

<style scoped>
    .calculator-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .calculator-container span {
        font-size: 30px;
        font-weight: 500;
    }
</style>
